import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add lead
export const addLead = async (formData) => {
  console.log("lead form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/create-lead`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// delete lead  API
export const deleteLead = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}crm/api/v1/delete-lead/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// update leads
export const updateLead = async (ROWID, data) => {
  console.log({ data })
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}crm/api/v1/update-lead/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count
export const countLead = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-leads-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getLeadDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-lead-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}


// Add lead
export const getLeadRelatedTasks = async (formData) => {
  console.log("lead form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-task-by-leadID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Add lead
export const getLeadRelatedNotes = async (formData) => {
  console.log("lead form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-notes-by-leadID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}